import axios from 'utils/axios';

/**
 * Fetch notifications with optional filters.
 */
export const getNotifications = (params = {}) =>
  axios.get('/notifications', { params }).then((res) => res.data);

/**
 * Fetch total unread count for header bell badge.
 */
export const getUnreadCount = () =>
  axios.get('/notifications/unread-count').then((res) => res.data);

/**
 * Mark a single notification as read.
 */
export const markAsRead = (id) =>
  axios.post(`/notifications/${id}/read`).then((res) => res.data);

/**
 * Mark a single notification as unread.
 */
export const markAsUnread = (id) =>
  axios.post(`/notifications/${id}/unread`).then((res) => res.data);

/**
 * Mark all visible notifications as read.
 */
export const markAllAsRead = () =>
  axios.post('/notifications/mark-all-read').then((res) => res.data);

/**
 * Mark all visible notifications as unread.
 */
export const markAllAsUnread = () =>
  axios.post('/notifications/mark-all-unread').then((res) => res.data);

export default {
  getNotifications,
  getUnreadCount,
  markAsRead,
  markAsUnread,
  markAllAsRead,
  markAllAsUnread
};
